// extracted by css-extract-rspack-plugin
export default {"runStatusInfo":"zte1C"};